import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.config.productionTip = false;
Vue.use(ElementUI);

// 生成唯一随机 ID 的函数
function generateRandomId() {
  return Math.floor(Math.random() * 1000000);
}

// 递归处理树形结构，生成随机 ID 并添加 parentId
function processTree(nodes, parentId = null) {
  return nodes.map((node) => {
    const newId = generateRandomId();
    const newNode = {
      ...node,
      id: newId,
      parentId,
    };
    if (node.children) {
      newNode.children = processTree(node.children, newId);
    }
    return newNode;
  });
}

const tree = [
  {
    id: 1,
    label: "一级 1",
    children: [
      {
        id: 4,
        label: "二级 1-1",
        children: [
          {
            id: 9,
            label: "三级 1-1-1",
          },
          {
            id: 10,
            label: "三级 1-1-2",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    label: "一级 2",
    children: [
      {
        id: 5,
        label: "二级 2-1",
      },
      {
        id: 6,
        label: "二级 2-2",
      },
    ],
  },
  {
    id: 3,
    label: "一级 3",
    children: [
      {
        id: 7,
        label: "二级 3-1",
      },
      {
        id: 8,
        label: "二级 3-2",
      },
    ],
  },
];

// 处理树形结构
const newTree = processTree(tree);

console.log(newTree);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
